const _UTILS = {
  async AddItemsToCart (items_to_add) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items_to_add })
    })
  },
  FormatMoney(value) {
    let USD = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    return USD.format(value/100);
  },
  async UpdateCartItems(updates) {
    return await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    }).then(res => res.json());
  },
  async ValidateCart_FG_items() {
    // to ensure free gift items are always quantity = 1
    let cart = await fetch('/cart.js').then(res => res.json());
    let fg_items = cart.items.filter(item => item.properties['__free-gift']);
    let fg_updates = {};

    fg_items.forEach((fg_item) => {
      let _bundle_id = fg_item.properties['_bundle_id'];
      let main_item = cart.items.find(item => !item.properties['__free-gift'] && item.properties['_bundle_id'] == _bundle_id);
      // console.log(_bundle_id, main_item)
      if (!main_item) {
        fg_updates[fg_item.key] = 0;
      }
      else {
        // ensure only 1 fg item per cart
        if (fg_item.quantity !== 1) {
          fg_updates[fg_item.key] = 1; 
        }
      }
    });

    if (JSON.stringify(fg_updates) == '{}') return;
    console.log('fix fg_quantity:', fg_updates);
    await _UTILS.UpdateCartItems(fg_updates);
    _UTILS.RefreshCart();
  },
  GetUniqId() {
    return "_" + Math.random().toString(36).substr(2, 9);
  },
  RefreshCart() {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {bubbles: true}));
  }
};

document.addEventListener('alpine:init', () => {
  Alpine.data('SubscriptionModule', (subscription_products, fg_gifts, isPrepaid_gift) => ({
    subscription_products: subscription_products,
    fg_gifts: fg_gifts,
    fg_gift: [],
    current_variant: null,
    price: {},
    cache: {},
    flags: {
      isPrepaid_gift: isPrepaid_gift
    },
    terms: isPrepaid_gift ? ['3-months','6-months','12-months'] : ['monthly','3-months','6-months','12-months'],
    selected_term: '3-months',
    savings: 0,
    init() {
      let am = this;
      am.InitSelf();
    },
    InitSelf() {
      let am = this;
      am.cache.$section = am.$el;

      am.$watch('current_variant', () => {
        am.UpdatePrice();
        am.savings = am.flags.isPrepaid_gift ? am.GetSavingsPrepaid() : am.GetSavings();
      });
      
      // preset variant to "3 Pouches" on load
      am.PreselectVariant();

      am.e_UpdateVariant();

      // on cart events, check free gifts
      let events = ['addedajaxProduct:added', 'cart:updated'];
      events.forEach((evt) => {
        document.addEventListener(evt, (e) => {
          // console.log(e)
          _UTILS.ValidateCart_FG_items();
        });
      });
      _UTILS.ValidateCart_FG_items();
    },
    GetSelectedVariant() {
      let am = this;
      let product = am.subscription_products[am.selected_term];
      // console.log({product});
      if (!product) return null;

      let selected_options = [...am.cache.$section.querySelectorAll('.product-options input[type=radio]:checked')].map($input => $input.value);
      let variant = product.variants.find(v => v.options.join('/') == selected_options.join('/'));
      // console.log({selected_options, variant});
      if (!variant) return null;
      return variant;
    },
    GetSelectedTermValue() {
      let am = this, term = 1;
      switch(am.selected_term) {
        case 'monthly': 
          term = 1; break;
        case '3-months': 
          term = 3; break;
        case '6-months': 
          term = 6; break;
        case '12-months': 
          term = 12; break;
      }
      return term;
    },
    GetSavings() {
      let am = this;
      let selected_options = am.current_variant.options;
      let selected_term = am.GetSelectedTermValue();


      let saving = 0;
      let values_to_match = `${selected_options[0]}-${selected_term}`;

      switch(values_to_match) {
        case '2 Pouches-6':
        case '2 Pouches-12':
          saving = 6; break;

        case '3 Pouches-1':
          saving = 11; break;
        case '3 Pouches-3':
          saving = 11; break;
        case '3 Pouches-6':
          saving = 15; break;
        case '3 Pouches-12':
          saving = 19.5; break;

        case '4 Pouches-1':
          saving = 16.5; break;
        case '4 Pouches-3':
          saving = 16.5; break;
        case '4 Pouches-6':
          saving = 23; break;
        case '4 Pouches-12':
          saving = 26; break;
      }
      return saving;
    },
    GetSavingsPrepaid() {
      let am = this;
      let selected_options = am.current_variant.options;
      let selected_term = am.GetSelectedTermValue();

      let saving = 0;
      let values_to_match = `${selected_options[0]}-${selected_term}`;

      switch(values_to_match) {
        case '2 Pouches-6':
          saving = 3.1; break;
        case '2 Pouches-12':
          saving = 8.7; break;        

        case '3 Pouches-3':
          saving = 6.1; break;  
        case '3 Pouches-6':
          saving = 8.2; break;  
        case '3 Pouches-12':
          saving = 15.3; break;  

        case '4 Pouches-3':
          saving = 19.4; break;  
        case '4 Pouches-6':
          saving = 24; break;  
        case '4 Pouches-12':
          saving = 26.5; break;  
      }
      return saving;
    },
    UpdatePrice() {
      let am = this;
      am.price.variant_price = am.current_variant.price;
      am.price.variant_price_money = _UTILS.FormatMoney(am.price.variant_price);

      am.price.monthly = am.price.variant_price / am.GetSelectedTermValue();
      am.price.monthly_money = _UTILS.FormatMoney(am.price.monthly);
    },
    PreselectVariant() {
      let am = this;
      let $3pouches = am.cache.$section.querySelector('input[value="3 Pouches"]');
      if ($3pouches) {
        $3pouches.checked = true;
        $3pouches.dispatchEvent(new Event('change', {bubbles: true}));
      }
    },
    e_UpdateVariant(e) {
      // console.log(e, this);
      let am = this;
      am.current_variant = am.GetSelectedVariant();
      am.fg_gift = am.fg_gifts[am.selected_term];
    },
    async e_AddToCart(e) {
      let am = this;
      let variant = am.GetSelectedVariant();
      if (!variant) {
        console.warn('No Variants matched!! Check configuration');
        return;
      }
      // console.log(variant);

      let _bundle_id = _UTILS.GetUniqId();
      
      let items_to_add = [{
        quantity: 1,
        id: variant.id,
        selling_plan: variant.selling_plan_allocations[0].selling_plan_id,
        properties: {
          _bundle_id
        }
      }];

      // Free gifts
      if (am.GetSelectedTermValue() !== 1) {
        let fg_gifts = am.fg_gifts[am.selected_term];
        if (fg_gifts.length) {
          fg_gifts.forEach((item) => {
            let fg_variant = item.variants.find(v => v.available);
            items_to_add.push({
              quantity: 1,
              id: fg_variant.id,
              properties: {
                '__free-gift': true,
                _bundle_id
              }
            });
          });
        }
      }

      const cartUpdate = await _UTILS.AddItemsToCart(items_to_add);
      window.SLIDECART_UPDATE(cartUpdate)
      if (am.cache.$section.dataset.addtocart_action == 'checkout') {
        window.location.href = '/checkout';
      }
      _UTILS.RefreshCart();
      window.SLIDECART_OPEN();
    }

    //   await _UTILS.AddItemsToCart(items_to_add);
    //   if (am.cache.$section.dataset.addtocart_action == 'checkout') {
    //     window.location.href = '/checkout';
    //   }
    //   _UTILS.RefreshCart();
    // }
  }));
});